import { useCallback, useEffect, useMemo, useRef, useState } from 'react'
import { AppState } from 'common/state-type'
import Constants from 'common/utils/constants'
import throttle from 'lodash/throttle'
import useArticles from 'common/providers/useArticles'
import Project from 'common/project'
import _data from 'common/utils/_data'
import { useNavigate } from 'react-router-dom'
import useLegalTermsGlossary from 'common/providers/useLegalTermsGlossary'

const SEARCH_DELAY = 500

export const TAB_LISTS = [
  'All',
  'A',
  'B',
  'C',
  'D',
  'E',
  'F',
  'G',
  'H',
  'I',
  'J',
  'K',
  'L',
  'M',
  'N',
  'O',
  'P',
  'Q',
  'R',
  'S',
  'T',
  'U',
  'V',
  'W',
  'X',
  'Y',
  'Z',
]

const pageSize = 200

export const useGlossaryTemplate = () => {
  const [selectedTab, setSelectedTab] = useState<string>(TAB_LISTS[0])
  const [searchValue, setSearchValue] = useState('')
  const { legalTermsGlossary, getLegalTermsGlossary } = useLegalTermsGlossary()

  const loadGlossaryTerms = useCallback(() => {
    getLegalTermsGlossary({})
  }, [getLegalTermsGlossary, selectedTab])

  let results = useMemo(() => {
    const records = legalTermsGlossary ?? []

    const grouped = groupedData(records)
    const docs = Object.values<any>(grouped)
    setSearchValue('')
    if (selectedTab === 'All') {
      return docs
    } else {
      return docs.filter(
        (value, index, self) =>
          index === self.findIndex(({ group }) => group === selectedTab),
      )
    }
  }, [legalTermsGlossary])

  const onFilterBySearch = useCallback((text: string) => {
    setSearchValue(text)
  }, [])

  if (searchValue) {
    const dd = results
      .map((d) =>
        d.children.filter(
          (d) => d.term.toLowerCase().indexOf(searchValue.toLowerCase()) > -1,
        ),
      )
      .flat()

    results = Object.values<any>(groupedData(dd))
  }

  return {
    selectedTab,
    setSelectedTab,
    searchValue,
    onFilterBySearch,
    results,
    loadGlossaryTerms,
  }
}

const groupedData = (data) => {
  return data.reduce((r, e) => {
    let group = e.term[0]
    if (!r[group]) r[group] = { group, children: [e] }
    else r[group].children.push(e)
    return r
  }, {})
}
